// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","items":"items-dzUrL","passenger":"passenger-3yQyb","baggage__passenger":"baggage__passenger-2Ww83"};